/* THE CREATOR DEPT. — tiny helpers. No dependencies. Each feature fails safely if its markup is missing. */
(function () {
  // Several sections load this file; only run once per page.
  if (window.__cdInit) return;
  window.__cdInit = true;

  // Mobile menu toggle
  document.querySelectorAll('[data-cd-menu-btn]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        btn.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        btn.focus();
      }
    });
  });

  // Product gallery: thumbnails swap the main image
  document.querySelectorAll('[data-cd-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-cd-main]');
    if (!main) return;
    g.querySelectorAll('[data-cd-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (!src) return;
        main.src = src;
        main.removeAttribute('srcset');
        main.alt = t.getAttribute('data-alt') || '';
        g.querySelectorAll('[data-cd-thumb]').forEach(function (o) { o.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });
})();
